export default __webpack_public_path__ + "static/media/unusual-Transaction.7d32dc68.svg";